export const STRATEGY = 'indirect';
export const DEFAULT_SLIPPAGE = 3;
export const SOL_ADDRESS = '11111111111111111111111111111111';
export const WRAPPED_SOL_ADDRESS = 'So11111111111111111111111111111111111111112';
export const DEFAULT_OPTIONS = {
    crossChainEnabled: true,
    transactionPrivacyNetworks: [],
};
export const NEW_TOKEN_ACCOUNT_FEE = 0.003;
export const UNKNOWN_FEES_BUFFER = 0.001;
export const whitelistedSimulationErrors = new Set([
    'Simulation API call failed.',
    'Slippage tolerance exceeded',
    'Exceeds desired slippage limit',
    'instruction exceeds desired slippage limit',
]);
